// Define actions, computed values and all necesary to manage the state client side
import { Store, SerializedData } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { observable, computed, action } from "mobx";
import {
  PackageWizardState,
  GlobalWizardState,
  LxWizardState,
  VrWizardState,
  CarWizardState,
  HotelWizardState,
  ThirdPartyPackageWizardState,
  CruiseWizardState,
  FlightWizardState,
  LOBState
} from "stores/wizard/state";
import { MultiLOBWizardConfig } from "./config";
import { LastSearchData } from "stores/wizard/LastSearchData";

export class ClientWizardStateStore extends Store {
  @observable
  private multiLOBWizardConfig: MultiLOBWizardConfig;

  @observable
  private lastSearchData?: LastSearchData;

  @observable
  public lobStateMap: any;

  @computed
  public get defaultLob() {
    return this.globalWizardState.defaultLob;
  }

  @computed
  public get useDefaultLOB() {
    return this.globalWizardState.useDefaultLOB;
  }

  public setUseDefaultLOB(useDefaultLOB: boolean) {
    this.globalWizardState.useDefaultLOB = useDefaultLOB;
  }

  @computed
  public get activeLob() {
    return this.globalWizardState.activeLob;
  }

  @action
  public setActiveLob(activeLob: string) {
    this.globalWizardState.setActiveLob(activeLob);
    if (this.lobStateMap[activeLob]) {
      (this.lobStateMap[activeLob] as LOBState).resetValidations();
    }
  }

  @observable
  private globalWizardState: GlobalWizardState;

  @observable
  public packageWizardState: PackageWizardState;

  @observable
  public lxWizardState: LxWizardState;

  @observable
  public vrWizardState: VrWizardState;

  @observable
  public carWizardState: CarWizardState;

  @observable
  public hotelWizardState: HotelWizardState;

  @observable
  public flightWizardState: FlightWizardState;

  @observable
  public thirdPartyPackageWizardState: ThirdPartyPackageWizardState;

  @observable
  public cruiseWizardState: CruiseWizardState;

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    this.multiLOBWizardConfig = data.multiLOBWizardConfig as MultiLOBWizardConfig;
    this.lastSearchData = data.lastSearchData as LastSearchData;
    this.globalWizardState = new GlobalWizardState(
      this.multiLOBWizardConfig.global,
      false,
      this.lastSearchData
    );

    this.packageWizardState = new PackageWizardState(
      this.multiLOBWizardConfig.package,
      this.globalWizardState,
      this.lastSearchData
    );

    this.lxWizardState = new LxWizardState(
      this.multiLOBWizardConfig.lx,
      this.globalWizardState,
      this.lastSearchData
    );

    this.vrWizardState = new VrWizardState(
      this.multiLOBWizardConfig.vr,
      this.globalWizardState,
      this.lastSearchData
    );

    this.carWizardState = new CarWizardState(
      this.multiLOBWizardConfig.car,
      this.globalWizardState,
      this.lastSearchData
    );

    this.hotelWizardState = new HotelWizardState(
      this.multiLOBWizardConfig.hotel,
      this.globalWizardState
    );

    this.flightWizardState = new FlightWizardState(
      this.multiLOBWizardConfig.flight,
      this.globalWizardState,
      this.lastSearchData
    );

    this.thirdPartyPackageWizardState = new ThirdPartyPackageWizardState(
      this.multiLOBWizardConfig.thirdPartyPackage
    );

    this.cruiseWizardState = new CruiseWizardState(this.multiLOBWizardConfig.cruise);

    this.lobStateMap = {
      "wizard-flight-pwa": this.flightWizardState,
      "wizard-car-pwa": this.carWizardState,
      "wizard-vr-pwa": this.vrWizardState,
      "wizard-package-pwa": this.packageWizardState,
      "wizard-lx-pwa": this.lxWizardState,
      "wizard-thirdPartyPackage-pwa": this.thirdPartyPackageWizardState,
      "wizard-cruise-pwa": this.cruiseWizardState,
      "wizard-hotel-pwa": this.hotelWizardState
    };
  }
}
